module.exports = __webpack_public_path__ + "img/kuang8@2x.6a33d7eb.png";